<template>
  <default-layout>
    <v-container>
      <v-row>
        <v-col md="12" class="text-center">
          <h1>DashBoard</h1>
        </v-col>
      </v-row>
    </v-container>
  </default-layout>
</template>

<script>
import DefaultLayout from "@/layouts/Default";
export default {
  name: "Export",
  components: {
    DefaultLayout
  },
  data() {
    return {

    };
  }
};
</script>
